export default (name, value) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(`ehomuteboards-${name}`, JSON.stringify(value));
  }
};
